import React from "react";
import { Box, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";

// Small green/red Yes-No toggle, echoing the color coding from the reference sheet.
export default function YesNoToggle({
  label,
  value,
  onChange,
  disabled,
  onLabel = "Yes",
  offLabel = "No",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "column" },
        alignItems: { xs: "flex-start", sm: "flex-start" },
        gap: { xs: 0.75, sm: 1 },
        mb: { xs: 0, sm: 2 },
        flex: { xs: "1 1 29%", sm: "1 1 29%" },
        minWidth: { xs: "auto", sm: "auto" },
      }}
    >
      <Typography variant="subtitle2" sx={{ textWrap:"nowrap" ,minWidth: { xs: "auto"} }}>
        {label}
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value ? "yes" : "no"}
        onChange={(e, val) => val && onChange(val === "yes")}
        disabled={disabled}
      >
        <ToggleButton
          value="yes"
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#43a047",
              color: "#fff",
              "&:hover": { backgroundColor: "#2e7d32" },
            },
          }}
        >
          {onLabel}
        </ToggleButton>
        <ToggleButton
          value="no"
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#e53935",
              color: "#fff",
              "&:hover": { backgroundColor: "#c62828" },
            },
          }}
        >
          {offLabel}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
